<template>
    <div>
        <button type="button" class="btn btn-sm btn-clean btn-icon btn-icon-sm" data-toggle="dropdown" data-target="#myModal">
            <i class="fa fa-cog"></i>
        </button>
        <div class="dropdown-menu">
            <button
                id="add_To_SuspectedIPs"
                @click="remindPayer(row.hashid)"
                class="dropdown-item"
            >
                {{ $t('money_request.remind_payer') }}
            </button>
        </div>
    </div>
    
</template>


<script>

import Vue from "vue";
import {mapGetters} from "vuex";
import toastr from "toastr";
import {moneyRequestService} from "@/common/api.service";


export default Vue.extend({
        props: {
            row: {
                required: true,
            },
            index: {
                required: true,
            },
            datatable: {
                required: true,
            }
        },
        computed: {
            toastr() {
                toastr.options = {
                    closeButton: true,
                    positionClass: "toast-top-left",
                    preventDuplicates: false,
                    rtl: false
                }

                return toastr
            }
        },

        methods: {
            remindPayer(hashid) {
                moneyRequestService.remind(hashid).then(response => {
                    this.toastr.success(response.data.message)
                }).catch(({response}) => {
                    this.toastr.fail(response.data.message)
                })
            },
        },
    })

</script>
